import { useElasticData, useExtraData } from "../DataContext.js";
import {decodeHTML} from '../../helpers.mjs';

const SeriesPanel = ({tabIndex, sel}) => {

    let { seriesData } = useElasticData();
    let { _source } = useExtraData();

    const name = `tab-${tabIndex}`;

    const seriesTable = () => {
        let tableHead = "<thead><tr><th>ISBN</th><th>Format</th><th>Title</th><th>Branches</th></tr></thead>"
        let tableRows = "";

        if(seriesData?.length > 0){
            seriesData.map(s => {
                tableRows += `<tr>`; // Start of the row
                const currentISBN = (_source.id ? _source.id : _source.isbn);
                if (currentISBN == s.ean13|| s.url == "") {
                    tableRows += `<td>${s.ean13}</td>`;
                } else if (s.url !== "") {
                    tableRows += `<td><a href="${s.url}">${s.ean13}</a></td>`;
                }
                tableRows += `<td>${s.format}</td>`;
                tableRows += `<td>${decodeHTML(s.title)}</td>`;
                tableRows += `<td>${s.branches.join(", ")}</td>`;
                tableRows += `</tr>`; // End of the row
            });
        }

        return `<table class="seriesTable">${tableHead}<tbody>${tableRows}</tbody></table>`;
    }

    // Series
    let _series = [];
    
    _series[0] = {
        "heading" : "",
        "rows" : {
            "" : seriesTable()
        }
    };

    // const seriesHeadings = _series.map(x => x.heading);
    const seriesRows = Object.values(_series.map(x => x.rows));
    let seriesHtml = "";

    seriesRows.map((row, i) => {
        let rowLabels = Object.keys(row);
        let rowValues = Object.values(row);
        let seriesRowsHtml = "";
        
        rowLabels.map((label, j) => {
            if(rowValues[j] && rowValues[j] != "") {
                seriesRowsHtml += `${label ? `<div class="half column"><strong>${label}</strong></div><div class="half column">${rowValues[j]}</div>` : `${rowValues[j]}`}`;
            }
        });
        seriesHtml += `<div class="column seriesTableContainer">${seriesRowsHtml}</div>`;
    });

    return(
        <>
            <div id={`tab-${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
                <div className="columns wrap" dangerouslySetInnerHTML={{__html: seriesHtml}} /> 
            </div>
        </>
    )
}

export default SeriesPanel;